import { faBars } from '@fortawesome/pro-regular-svg-icons';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React, { useEffect, useRef, useState } from 'react';
import { Icon } from 'src/components/Icon';
import { SafeArea } from 'src/components/SafeArea';
import { useWindowSize } from 'src/utils/useWindowSize';

export interface MobileAppHeaderProps {
  onClickBack?: () => void;
  onClickHamburger?: () => void;
  navigation?: React.ReactNode;
  title: string | React.ReactNode;
  row?: React.ReactNode;
  actions?: React.ReactNode;
}

export const MobileAppHeader: React.FC<MobileAppHeaderProps> = ({
  title,
  actions,
  row,
  onClickHamburger,
  navigation,
}) => {
  const actionsWrapperRef = useRef<HTMLElement | null>(null);
  const [actionsWrapperWidth, setActionsWrapperWidth] = useState(0);
  const { width: windowWidth } = useWindowSize();

  useEffect(() => {
    if (!actions || !actionsWrapperRef.current?.clientWidth) {
      return;
    }
    setActionsWrapperWidth(actionsWrapperRef.current?.clientWidth);
  }, [actions]);

  const centerTitle = actionsWrapperWidth > windowWidth / 3;
  const navigationColWidth = centerTitle
    ? undefined
    : actionsWrapperWidth + 'px';

  return (
    <SafeArea top>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxWidth: '100vw',
          minHeight: '55px',
        }}
      >
        <Box
          sx={{
            p: 1,
            width: navigationColWidth,
            minWidth: '56px',
          }}
        >
          {onClickHamburger && (
            <IconButton onClick={onClickHamburger} sx={{ mr: 1 }}>
              <Icon
                size="medium"
                icon={faBars}
              />
            </IconButton>
          )}
          {navigation && navigation}
        </Box>
        <Typography noWrap variant="h6">
          {title}
        </Typography>
        <Box
          sx={{
            flexShrink: 0,
            minWidth: '56px',
            display: 'flex',
            flexDirection: 'row-reverse',
            p: 1,
          }}
          ref={actionsWrapperRef}
        >
          {actions}
        </Box>
      </Box>
      {row && <Box>{row}</Box>}
    </SafeArea>
  );
};
